import {
    Component,
    Input,
    OnInit,
    OnChanges, effect} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import dayjs from 'dayjs';
import { IdentifierService } from 'merlin-core';
import { LocalizationService } from 'src/core/utilitites/localization.service';

import { ViewleadsDialogComponent } from '../../viewleads-dialog/viewleads-dialog.component';
import { AVEIR_ALL_CODES, AVEIR_VR_CODES, AVEIR_AR_CODES } from '../../device-transmit-information/device-codes.constants';
@Component({
    selector: 'view-device-transmit-information',
    templateUrl: './view-device-transmit-information.component.html',
    styleUrls: ['./view-device-transmit-information.component.scss'],
    standalone: false
})
export class ViewDeviceTransmitInformationComponent implements OnInit, OnChanges {
    private readonly aveirLpCodes = new Set(AVEIR_ALL_CODES);
    private readonly aveirVrCodes = new Set(AVEIR_VR_CODES);
    private readonly aveirArCodes = new Set(AVEIR_AR_CODES);
    public aveirPairLabel: string = '';
    public isAveir: boolean = false;
    @Input() dataMiningFlg = false;
    @Input() activatorClinicFlg;
    @Input() functionMode: string;
    @Input() displayMode: string;
    @Input() patRes: any;
    @Input() orderTransmitterMsg: string;
    @Input() public dateLabel;
    @Input() public showPhysicianOpt = false;
    @Input() public isNGQCategory;
    @Input() public isICMCategory;
    @Input() public isLPCategory:boolean = false;

    public stringLabels = [
        "label.gb.device_data",
        "label.gb.view_leads",
        "label.gb.serial_number",
        "label.gb.dev_name",
        "label.gb.implant_date",
        "label.gb.doc_perform_implant",
        "label.gb.lead_chamber",
        "label.gb.DR_chk",
        "label.gb.dev_name",
        "label.gb.doc_perform_implant",
        "label.gb.device_label",
        "label.gb.transmitter",
        "label.gb.order_transmit",
        "label.gb.pat_has_trans",
        "label.gb.record_data_collection_consent",
        "label.gb.selectDR",
        "label.gb.DR"
    ]

    public labels: Record<string, string>;

    constructor(
        public dialog: MatDialog,
        public identifierService: IdentifierService,
        private localizationService: LocalizationService,
    ) {
        effect(() => {
            const lang = this.localizationService.currentLang();
            if (!lang) return;
            this.labels = this.localizationService.reparseLocalizedStrings(this.labels);
        });
    }

    ngOnInit() {
        this.translateStrings();
        this.aveirPairLabel = this.labels['label.gb.selectDR'];
    }

    ngOnChanges(change) {
            if(change?.patRes?.currentValue && this.isAveirDevice()){
                this.getAveirPairLabel();
                const productId = this.patRes?.patientDevices?.[0]?.productId;
                this.isAveir = productId ? this.aveirLpCodes.has(String(productId)) : false;
            }
    }

    ngAfterViewInit() {

    }

    translateStrings(){
        this.labels = this.localizationService.appendStringLabelsToRecord(this.labels, this.stringLabels);
    }

    showingPhysicalDropdownVal(){
        let productId = this.patRes?.patientDevices?.[0]?.productId;
        let prodIds= this.patRes?.clinicDetails?.icmProdIds;

        if(prodIds?.split(',').includes(productId?.toString())){
            return true;
        }else{
            return false;
        }
    }

    getOrdTrDate(){
        let dateToReturn = "";
        if (this.patRes.patient) {
            const dt = this.patRes.patient.transmitterOrderDate;
            const tz = this.dateLabel?.toUpperCase() || 'DD/MM/YYYY';
            const dateTimeFormat = `${tz} h:mm A`;
            dateToReturn = this.localizationService.generateLocalizedStr(
                'label.gb.transmitter_order_date',
                { '0': dt ? dayjs(dt).format(dateTimeFormat) : '--' },
                'text'
            );
        }
        return dateToReturn;
    }


    getTrueAAIInfoFlag(){
        const trueAAIProdIds = this.patRes.clinicDetails?.trueAAIProdIds?.split(',') || [];
        return trueAAIProdIds.includes(String(this.patRes?.patientDevices?.[0]?.productId));
    }

    get isImplantPhysicianEditable(){
        return this.patRes.isImplantPhysicianEditable;
    }

    // Get transferred patient implanting physician details
    getTransferredImplantingPhys(data: any): string {
        if (!data || !data.patientDevices || !data.patientDevices[0]) return "--"; // Handle undefined data
        const { implantPhyLastName, implantPhyFirstName, implantPhyMiddleName, implantPhyCredentialsCd } = data.patientDevices[0];
        // Add a comma after the last name only if it exists
        const formattedLastName = implantPhyLastName ? implantPhyLastName + "," : "";
        // Filter out empty values while ensuring a comma is placed correctly
        const formattedName = [
            formattedLastName.trim(),  // Last Name with comma
            implantPhyFirstName,       // First Name
            implantPhyMiddleName,      // Middle Name
            implantPhyCredentialsCd    // Credentials
        ]
        .filter(item => item && item.trim() !== '') // Remove null/empty values
        .join(' '); // Join with space

        return formattedName || "--"; // Ensure "--" is returned if all fields are empty
    }

    getTransPatientImplantPhyIdData(){
        return this.getTransferredImplantingPhys(this.patRes);
    }

    showOrderTransmitterSection(){
        if(this.patRes == null){
            return false;
        } else {
            return (!this.isNGQCategory && !this.isICMCategory && !this.isLPCategory);
        }
    }

    displayViewUI() {
        if (this.functionMode == 'profile' && this.displayMode == 'view') {
            return true;
        } else {
            return false;
        }
    }

    getDeviceName() {
        let patDevice = this.patRes.dropdowns
            ? this.patRes.dropdowns.devices.filter((dev) => {
                return dev.value == this.patRes.patientDevices?.[0]?.productId;
            })
            : [];
        return patDevice.length !== 0 ? patDevice[0]?.label : this.patRes?.patientDevices?.[0]?.deviceFullDescription;
    }

    getTransmitterVisibleOnEmpty(){
        return (this.isICMCategory || this.isNGQCategory || this.isLPCategory) ? false : true;
    }

    private formatPhysician(patPhys: any): string {
        if (patPhys?.length == 0 || patPhys === null || patPhys === undefined) return '';
        patPhys.middleName = null; // Clear middle name as per original logic
        const name = [
            patPhys?.lastName ? `${patPhys.lastName},` : '',
            patPhys?.firstName ?? '',
            patPhys?.middleName ?? '',
            patPhys?.credentialsCd ?? ''
        ]
        .map(s => String(s).trim())
        .filter(s => s.length > 0)
        .join(' ');
        return patPhys?.mainLocation ? `${patPhys.mainLocation}: ${name}` : name;
    }

    getImplantingPhys() {
        let patPhys = this.patRes.dropdowns?.clinicians.filter((dev) => {
            return dev.acctId == this.patRes?.patientDevices?.[0]?.implantPhyId;
        })[0];
        return this.formatPhysician(patPhys);
    }

    getDrImplantingPhys() {
        let patPhys = this.patRes.dropdowns?.clinicians.filter((dev) => {
            return dev.acctId == this.patRes?.patientDevices?.[1]?.implantPhyId;
        })[0];
        if(!patPhys && this.patRes?.patientDevices?.[1]?.implantPhyId){
            patPhys = {
                firstName: this.patRes.patientDevices?.[1]?.implantPhyFirstName,
                lastName: this.patRes.patientDevices?.[1]?.implantPhyLastName,
                middleName: this.patRes.patientDevices?.[1]?.implantPhyMiddleName,
                credentialsCd: this.patRes.patientDevices?.[1]?.implantPhyCredentialsCd,
                mainLocation: this.patRes.patientDevices?.[1]?.implantPhyMainLocation
            };
        }
        return this.formatPhysician(patPhys);
    }

    getChamb() {
        let patChamb = this.patRes?.dropdowns.leadChmbCodes.filter((code) => {
            return code.codeId == this.patRes.patientDevices?.[0]?.leadChmbSettingCd;
        });
        if (patChamb.length == 0) {
            return '';
        }else{
            return this.localizationService.generateLocalizedStr("data.Code."+patChamb[0].qualifier+".Code_Desc."+patChamb[0].code);
        }
    }
    getSerialNum() {
        let patSerNum = this.patRes?.patientDevices?.[0]?.serialNum;
        while (patSerNum && patSerNum.toString().indexOf('0') === 0) patSerNum = patSerNum.replace('0', '')
        return patSerNum;
    }

    getImpDate() {
        let impDate = this.patRes?.patientDevices?.[0]?.implantDate?.toString();
        return impDate ? impDate : '';
    }

    openViewLeadsDialog() {
        const dialogRef = this.dialog.open(ViewleadsDialogComponent, {
            width: '50%',
            data: this.patRes,
        });
        dialogRef.afterClosed().subscribe((result) => {

        });
    }

    disableTransmitterRadioBtn() {
        if (this.functionMode == 'enroll') {
            return false;
        } else if (
            this.functionMode == 'profile' &&
            this.displayMode == 'view'
        ) {
            return true;
        } else {
            return true;
        }
    }

    translate(key: string) {
        return this.localizationService.generateLocalizedStr(key);
    }

    isAveirDevice(): boolean {
        const productId = this.patRes?.patientDevices?.[0]?.productId;
        if (!productId) return false;
        const code = String(productId);
        return this.aveirLpCodes.has(code);
    }

    getAveirPairLabel() {
        const device1 = this.patRes?.patientDevices[0];
        const device2 = this.patRes?.patientDevices[1];
        
        const primaryCode = String(device1?.productId || '').trim();
        const drCode = String(device2?.productId || '').trim();
        
        // Check if we have one AR and one VR device
        const hasAr = this.aveirArCodes.has(primaryCode) || this.aveirArCodes.has(drCode);
        const hasVr = this.aveirVrCodes.has(primaryCode) || this.aveirVrCodes.has(drCode);

        // Extract model numbers in the order they appear (Device name, then DR Device name)
        const model1 = this.extractModelNumber(device1?.deviceFullDescription);
        const model2 = this.extractModelNumber(device2?.deviceFullDescription);
        if (!this.patRes?.patientDevices?.[0] || !this.patRes?.patientDevices?.[1]) {
            this.aveirPairLabel = this.labels['label.gb.selectDR'];
        }
        else if (!hasAr || !hasVr) {
            this.aveirPairLabel = this.labels['label.gb.selectDR'];
        }
        else if (!model1 || !model2) {
            this.aveirPairLabel = this.labels['label.gb.selectDR'];
        }
        else{
         this.aveirPairLabel =  `${this.labels['label.gb.DR']} ${model1} / ${model2}`;
        }
    }
    
    private extractModelNumber(deviceFullDescription: string): string | null {
        if (!deviceFullDescription) return null;
        // Extract the last part after the last space (e.g., "Aveir™ VR LSP202V" -> "LSP202V")
        const parts = deviceFullDescription.trim().split(' ');
        return parts.length > 0 ? parts[parts.length - 1] : null;
    }
}
